import cards from '../../assets/images/newui/cards.png'
import exCards from '../../assets/images/newui/existing-card.svg'
import SellerStripeFormHOC from './SellerStripeFormHOC'
import { Grid } from 'semantic-ui-react';
import { CardExpiryElement, CardCvcElement, CardNumberElement } from '@stripe/react-stripe-js';
import React, { Component } from 'react';
import './SellerStripeForm.less'

class SellerStripeForm extends Component {
    render() {
        const { isSmall, areCardsExists, onExistingCardsClick, changeHandler, hideDisclaimer } = this.props;
        return <div className="stripe-form-container">
            <div className="stripe-form-header">Payment Info</div>
            {areCardsExists ? <div onClick={onExistingCardsClick} className='stripe-form-existing-btn'>
                <span>
                    Existing Cards
                    </span>
                <img src={exCards} /> </div> : ''}
            <Grid className='stripe-form-grid'>
                <Grid.Column computer={isSmall ? 16 : 12} tablet={isSmall ? 16 : 12} mobile={16}>
                    <div className='field card-number-field'>
                        <div className='cards-img'><img src={cards} /></div>
                        <label>
                            Credit Card Number
                            </label>
                        <CardNumberElement onChange={changeHandler} options={{ placeholder: '(0000 0000 0000 0000)' }} />
                    </div>
                </Grid.Column>
                <Grid.Column computer={isSmall ? 16 : 4} tablet={isSmall ? 16 : 4} mobile={16} >
                    <div className='field'>
                        <label>
                            Card Expiry
                            </label>
                        <CardExpiryElement onChange={changeHandler} />
                        <div className='required'>*</div>
                    </div>
                </Grid.Column>
                <Grid.Column width={16} >
                    <div className='field'>
                        <label>
                            CVC
                            </label>
                        <CardCvcElement onChange={changeHandler} />
                        <div className='required'>*</div>
                    </div>
                </Grid.Column>
            </Grid>
        </div>
    }
}

export default SellerStripeFormHOC(SellerStripeForm);